import meetingsService from '../src/services/meetingsDataService';

export default class Config {
    
    public static meet: IMeetConfig;

    public static me?: IMe;
    
    public static token?: ITokenInfo;

    public static ctx: IContext;

    public static lastVisitDate?: Date;

    private static joinUrlPromise: Promise<string>;
    private static joinUrl: string;

    public static getJoinUrlAsync(): Promise<string> {
        if (this.joinUrl) {
            return Promise.resolve(this.joinUrl);
        }

        if (!this.joinUrlPromise) {
            this.joinUrlPromise =  meetingsService.getQuickMeetAsync()
            .then(meet => {
                this.joinUrl = `${this.meet.hosts.web}/${meet.code}`; 
                return this.joinUrl
            });
        }

        return this.joinUrlPromise;
    }
}

